import { useState } from "react";
import { Box, Chip, Typography } from "@mui/material";
import FormInput from "../Common/FormInputs/MuiTextField";
import { useDesignTokens } from "../../theme/useDesignTokens";

const ChipTextInput = ({
  id = "chip-text-input",
  label,
  value = [],
  onChange,
  placeholder = "Type and press Enter",
  error,
  helperText,
  disabled,
}) => {
  const { colors } = useDesignTokens();
  const [inputValue, setInputValue] = useState("");

  const addValue = (raw) => {
    const trimmed = raw.trim();
    if (!trimmed || value.includes(trimmed)) return;
    onChange([...value, trimmed]);
    setInputValue("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addValue(inputValue);
    }
  };

  const removeValue = (item) => {
    onChange(value.filter((v) => v !== item));
  };

  return (
    <Box>
      <FormInput
        id={id}
        label={label}
        size="small"
        fullWidth
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={() => addValue(inputValue)}
        placeholder={placeholder}
        error={error}
        helperText={helperText}
        disabled={disabled}
      />
      {value.length > 0 && (
        <Box
          sx={{
            mt: 1.5,
            p: 1.25,
            borderRadius: 1.5,
            border: `1px solid ${colors?.ghost?.light || "#E0E0E0"}`,
            bgcolor: "background.paper",
          }}
        >
          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.75 }}>
            {value.length} added — press Enter to add more
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
            {value.map((item) => (
              <Chip
                key={item}
                label={item}
                size="small"
                color="primary"
                variant="outlined"
                onDelete={disabled ? undefined : () => removeValue(item)}
              />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ChipTextInput;
